// extracted by mini-css-extract-plugin
module.exports = {"sectionFAQ":"style-module--sectionFAQ--rQTFq","title":"style-module--title--3u4jt"};